import React from 'react'

const SvgCalendarCheckFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 12.919l-4.93 4.998-1.13-1.146A2.866 2.866 0 009.646 17h-.644c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h.008c.036.698.313 1.386.84 1.92L10.913 22H6c-1.333 0-2-.667-2-2V10h16v2.919zM9.002 13c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998zm5 0c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998z'
    />
    <path d='M16 2c.667 0 1 .314 1 .941V4h1c1.333 0 2 .667 2 2v2H4V6.004C4 4.668 4.667 4 6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.72 14.284a.98.98 0 010 1.37l-6.953 7.062a.943.943 0 01-1.348 0l-3.14-3.189a.98.98 0 010-1.37.943.943 0 011.349 0l2.465 2.505 6.28-6.378a.943.943 0 011.348 0z'
    />
  </svg>
)

export default SvgCalendarCheckFilled
